import React from 'react';

export default function RoadmapSection() {
  const year1Goals = [
    {
      icon: 'ri-smartphone-line',
      title: 'Launch OxyAI™ App',
      target: '10,000 people',
      description: 'Comprehensive oxygen screening for early detection'
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'Distribute OxyKits',
      target: '5,000 kits',
      description: 'Complete supplementation packages for high-need communities'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Train ASHA Workers',
      target: '100 workers',
      description: 'Community health advocates in rural districts'
    }
  ];

  const year2to3Goals = [
    {
      icon: 'ri-map-2-line',
      title: 'Expand Coverage',
      target: '25 districts',
      description: 'Nationwide presence across India'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Mass Screening',
      target: '1,00,000+ people',
      description: 'Large-scale oxygen deficiency assessment'
    },
    {
      icon: 'ri-truck-line',
      title: 'Kit Distribution',
      target: '50,000+ kits',
      description: 'Widespread supplementation program'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Publish Research',
      target: 'Scientific studies',
      description: 'Evidence-based oxygen deficiency research'
    }
  ];

  return (
    <section id="roadmap-section" className="py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Our Roadmap for Impact
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            A phased approach to building India's first oxygen-first healthcare movement, 
            with clear milestones and measurable outcomes.
          </p>
        </div>

        {/* Year 1 Goals */}
        <div className="mb-16">
          <div className="flex items-center mb-8">
            <div className="w-12 h-12 bg-[#12B6B6] rounded-2xl flex items-center justify-center mr-4">
              <span className="text-white font-bold">Y1</span>
            </div>
            <h3 className="text-2xl font-bold text-[#111111]">Year 1 Goals (Pilot Phase)</h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {year1Goals.map((goal, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${goal.icon} text-2xl text-[#12B6B6]`}></i>
                </div>
                <h4 className="text-xl font-bold text-[#111111] mb-2">{goal.title}</h4>
                <div className="text-2xl font-bold text-[#12B6B6] mb-3">{goal.target}</div>
                <p className="text-sm text-gray-600 leading-relaxed">{goal.description}</p>
                
                {/* Progress placeholder */}
                <div className="mt-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs text-gray-500">Planning Phase</span>
                    <span className="text-xs text-[#12B6B6] font-medium">Ready to Launch</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2">
                    <div className="w-3/4 h-2 bg-[#12B6B6] rounded-full"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Year 2-3 Goals */}
        <div>
          <div className="flex items-center mb-8">
            <div className="w-12 h-12 bg-gradient-to-r from-[#12B6B6] to-[#0891B2] rounded-2xl flex items-center justify-center mr-4">
              <span className="text-white font-bold text-sm">Y2-3</span>
            </div>
            <h3 className="text-2xl font-bold text-[#111111]">Year 2-3 Goals (Scale Phase)</h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {year2to3Goals.map((goal, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-14 h-14 bg-gradient-to-r from-[#12B6B6] to-[#0891B2] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${goal.icon} text-xl text-white`}></i>
                </div>
                <h4 className="text-lg font-semibold text-[#111111] mb-2">{goal.title}</h4>
                <div className="text-xl font-bold text-[#12B6B6] mb-2">{goal.target}</div>
                <p className="text-xs text-gray-600 leading-relaxed">{goal.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Timeline Summary */}
        <div className="mt-16 bg-gradient-to-r from-[#12B6B6] to-[#0891B2] rounded-3xl p-8 text-white">
          <div className="text-center max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">3-Year Impact Projection</h3>
            <p className="text-white/90 mb-8">
              By Year 3, we aim to establish the foundation for India's oxygen-first healthcare system, 
              with proven outcomes and scalable solutions.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">1.1L+</div>
                <div className="text-sm text-white/80">People Screened</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">55K+</div>
                <div className="text-sm text-white/80">OxyKits Distributed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">25</div>
                <div className="text-sm text-white/80">Districts Covered</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
